import React from 'react'
import { InputTextarea } from 'primereact/inputtextarea'

const InputTextareaComp = ({ name, value, onChange, rows, cols }) => {
  return (
    <InputTextarea
      name={name}
      value={value}
      onChange={onChange}
      rows={rows || 5}
      cols={cols || 3}
    />
  )
}

export default InputTextareaComp
